// Mock data for LifeProof AI Landing Page

export const siteConfig = {
  name: "LifeProof AI",
  tagline: "Secure incident documentation and report generation.",
  supportEmail: "support@lifeproofai.com",
  chargesDisclaimer: "Charges may appear as 'LIFEPROOF AI' on statements.",
  cancellationNote: "Cancel anytime in your account settings."
};

export const features = [
  {
    id: 1,
    icon: "Shield",
    title: "Secure Storage",
    description: "Secure storage for photos, videos, audio, and documents with end-to-end encryption."
  },
  {
    id: 2,
    icon: "Clock",
    title: "Incident Timelines",
    description: "Organized incident timelines and structured documentation for clear record-keeping."
  },
  {
    id: 3,
    icon: "FileText",
    title: "AI Reports",
    description: "AI-assisted summaries and downloadable reports for your records."
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Document",
    description: "Capture and upload photos, videos, audio, or documents securely."
  },
  {
    step: 2,
    title: "Organize",
    description: "Create timelines and categorize your documentation automatically."
  },
  {
    step: 3,
    title: "Generate",
    description: "Get AI-assisted summaries and download professional reports."
  }
];

export const pricingPlans = [
  {
    id: "free",
    name: "Free",
    price: "$0",
    period: "forever",
    description: "Get started with basic documentation",
    features: [
      "Up to 5 incidents",
      "Basic photo & document storage",
      "Manual timeline creation",
      "Standard reports"
    ],
    cta: "Get Started",
    highlighted: false
  },
  {
    id: "pro",
    name: "Pro",
    price: "$9.99",
    period: "/month",
    description: "Full power for comprehensive documentation",
    features: [
      "Unlimited incidents",
      "Video & audio storage",
      "AI-powered timelines",
      "Advanced AI summaries",
      "Priority support"
    ],
    cta: "Join Waitlist",
    highlighted: true
  }
];

export const faqItems = [
  {
    id: 1,
    question: "What is LifeProof AI?",
    answer: "LifeProof AI is a secure documentation platform that helps you organize, store, and generate reports from your personal records. It's designed for individuals who need to maintain organized documentation of incidents or events."
  },
  {
    id: 2,
    question: "How is my data protected?",
    answer: "Your data is encrypted both in transit and at rest. We use industry-standard security practices to ensure your documentation remains private and accessible only to you. We never share your data with third parties."
  },
  {
    id: 3,
    question: "What LifeProof AI is NOT",
    answer: "LifeProof AI is not legal advice, and we are not a law firm. Our reports are for personal record-keeping purposes. We do not provide emergency services or real-time monitoring capabilities."
  },
  {
    id: 4,
    question: "How do I cancel my subscription?",
    answer: "You can cancel your subscription anytime through your account settings. Your data will remain accessible until the end of your billing period, after which you can export your records before account closure."
  },
  {
    id: 5,
    question: "Can I export my data?",
    answer: "Yes, you can export all your documentation, timelines, and reports at any time. We believe your data belongs to you, and you should always have full access to download and use it as needed."
  }
];

export const navLinks = [
  { label: "Features", href: "#features" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" }
];

export const footerLinks = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Refund Policy", href: "/refunds" },
  { label: "Contact", href: "/contact" }
];
